import { CarReservation, CarType, CarTypeData } from './../itineray.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-itinerary-reservations-car-form-title',
  templateUrl: './itinerary-reservations-car-form-title.component.html',
  styleUrls: ['./itinerary-reservations-car-form-title.component.css']
})
export class ItineraryReservationsCarFormTitleComponent implements OnInit {

  @Input()
  car: CarReservation;

  constructor() { }

  ngOnInit() {
  }

  getCarTypeData(carType: CarType) {
    return CarTypeData.get(carType);
  }

}
